import React from "react";
import { Route, Redirect } from "react-router-dom";
import { ScrollToTop } from "../../dumb-components";

export default function PrivateRoute({
  component: Component,
  exact,
  roles,
  path,
  ...rest
}) {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(props) => {
        const currentUser = localStorage.getItem("token"); //For demo only
        if (!currentUser) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }
        // check if route is restricted by role
        // if (roles && roles.indexOf(currentUser.role) === -1) {
        // role not authorised so redirect to home page
        // return <Redirect to={{ pathname: "/" }} />;
        // }

        // authorised so return component
        return (
          <div className="main-body-wrapper">
            <ScrollToTop>
              <div className="main-wrapper">
                <Component {...props} />
              </div>
            </ScrollToTop>
          </div>
        );
      }}
    />
  );
}
